/** Stable key for live-context VM lists (supports API `vmId` or legacy `id`). */
export function liveContextVmFingerprint(vm: { vmId?: string; id?: string; status: string }): string {
  const id = vm.vmId ?? vm.id ?? '';
  return `${id}:${vm.status}`;
}
